/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

/**
 * True when a keyboard event should activate a button-like control (Enter or
 * Space). Single source of truth so call sites don't drift on `e.key` vs
 * `e.code` or the legacy `"Spacebar"`. Caller owns `preventDefault`.
 */
export const isActivationKey = (event) =>
  event.key === "Enter" || event.key === " " || event.key === "Spacebar";
